import React from "react";
import { Search, Map, Rocket, BarChart3, RefreshCcw } from "lucide-react";

const STEPS = [
  { icon: Search, title: "Analyse", desc: "Wir prüfen Markt, Wettbewerb, Zielgruppe und Status quo deiner Kanäle – ohne Schönfärberei." },
  { icon: Map, title: "Strategie", desc: "Klare Positionierung, Botschaften, Funnel und KPIs. Du weißt vor dem Launch, wohin die Reise geht." },
  { icon: Rocket, title: "Content & Umsetzung", desc: "Produktion, Postings, Community-Pflege – alles aus einer Hand. Wöchentlicher Output, der nicht nach Schema F aussieht." },
  { icon: BarChart3, title: "Wachstum", desc: "Reichweite, Follower und Anfragen wachsen messbar – organisch. Du siehst genau, welche Inhalte ziehen und welche nicht." },
  { icon: RefreshCcw, title: "Optimierung", desc: "Monatliche Reviews, schnelle Iteration, ständiges Testing. Was funktioniert, wird skaliert." },
];

export default function Process() {
  return (
    <section id="prozess" data-testid="process-section" className="hh-section bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="hh-eyebrow justify-center inline-flex mb-5">Prozess</div>
          <h2 className="hh-headline text-[2.3rem] sm:text-[3rem] lg:text-[3.6rem] text-[#2E2E2E]">
            Vom ersten Gespräch bis zum <span className="hh-highlight">vollen Hafenbecken.</span>
          </h2>
          <p className="font-body text-[#2E2E2E]/70 text-base sm:text-lg mt-5">
            Fünf klare Etappen. Keine Geheimnisse, keine Buzzword-Folien. Du weißt
            jederzeit, woran wir gerade arbeiten und warum.
          </p>
        </div>

        <div className="relative">
          {/* connecting line (desktop) */}
          <div className="hidden lg:block absolute top-12 left-[8%] right-[8%] h-[2px] bg-gradient-to-r from-[#FFF44F] via-[#2185D0] to-[#FFF44F]" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={s.title} data-testid={`process-step-${i}`} className="relative">
                  <div className="relative flex flex-col items-center text-center">
                    <div className="relative w-24 h-24 rounded-full bg-white border-2 border-[#2E2E2E] flex items-center justify-center">
                      <Icon className="w-9 h-9 text-[#2E2E2E]" strokeWidth={1.8} />
                      <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#FFF44F] border-2 border-white flex items-center justify-center font-display text-sm text-[#2E2E2E]">
                        0{i + 1}
                      </div>
                    </div>
                    <div className="mt-5 font-display text-[#2E2E2E] text-xl">{s.title}</div>
                    <p className="mt-2 font-body text-[0.88rem] text-[#2E2E2E]/65 leading-relaxed max-w-[220px]">{s.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
